var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('ul',{staticClass:"info-lines"},_vm._l((_vm.info_slugs_final),function(slug,index){return _c('li',{key:index},[(slug == 'timings_in_timezone' && _vm.timezone)?_c('div',{domProps:{"innerHTML":_vm._s(
        _vm.Tsprintf(
          /* translators: 1: html-tag-open 2: html-tag-close 3: timezone */
          _vm.T__(
            'All timings in this page are in %1$s %3$s %2$s Time Zone as per Event Type settings.'
          ),
          '<span style="font-weight:500">',
          '</span>',
          _vm.timezone
        )
      )}}):(_vm.get_info_by_slug(slug))?_c('div',[_vm._v(" "+_vm._s(_vm.get_info_by_slug(slug))+" ")]):_vm._e()])}),0)}
var staticRenderFns = []

export { render, staticRenderFns }